let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4j2De")).then(() => parcelRequire('fqv9g'));